import { useEffect, useState } from "react";
import AdminLogin from "@/admin/AdminLogin";
import AdminPanel from "@/admin/AdminPanel";
import Seo from "@/components/Seo";
import { apiMe, getToken, setToken } from "@/admin/adminApi";
import "@/admin/admin.css";

const AdminApp = () => {
  const [checked, setChecked] = useState(false);
  const [email, setEmail] = useState(null);

  useEffect(() => {
    if (!getToken()) {
      setChecked(true);
      return;
    }
    apiMe()
      .then((res) => {
        setEmail(res.data.email);
        setChecked(true);
      })
      .catch(() => {
        setToken(null);
        setChecked(true);
      });
  }, []);

  const handleLogout = () => {
    setToken(null);
    setEmail(null);
  };

  if (!checked) {
    return <div className="admin-loading">Loading...</div>;
  }

  const seo = (
    <Seo title="Admin Panel" description="IT Device Services administration." path="/admin" noindex />
  );

  if (!email) {
    return (
      <>
        {seo}
        <AdminLogin onLogin={setEmail} />
      </>
    );
  }

  return (
    <>
      {seo}
      <AdminPanel email={email} onEmailChange={setEmail} onLogout={handleLogout} />
    </>
  );
};

export default AdminApp;
